<template>
   <div>
      <Header></Header>
      <main class="APP-contents">
         <div class="type">
            <div class="result-first-section">
               <div class="margin-vert-40px large-margin-vert-100px">
                  <div class="container">
                     <div class="medium-row-gutter-50px flex-direction-row-reverse align-items-center relative">
                        <div class="medium-col-6of12 type-result-figure-wrapper">
                           <div class="result-figure"><img class="img-responsive" v-bind:src="`${publicPath}static/img/pages/result/type/${typeId}/figure_01.png`"></div>
                        </div>
                        <div class="medium-col-6of12">
                           <div class="result-header">
                              <span class="result-header__shoulder result-header__shoulder--background-color-ffffff">あなたは</span>
                              <h1 class="result-header__heading" style="position: relative; z-index: 1;" v-html="typeSet.personalityType"></h1>
                           </div>
                           <div class="result-subheader">
                              <h2 class="result-subheader__heading" v-html="typeSet.personalityTypeHeadlineText"></h2>
                           </div>
                           <p class="result-body-text" v-html="typeSet.personalityTypeBodyText"></p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="workstyle">
            <div class="component-header-B01">
               <h2 class="component-header-B01__heading">みらいのあなたは、<br class="large-display-none">どんな働き方をしているでしょう。</h2>
            </div>
            <div class="result-second-section">
               <div class="margin-vert-40px large-margin-vert-100px">
                  <div class="container">
                     <div class="medium-row-gutter-50px align-items-center relative">
                        <div class="medium-col-6of12">
                           <div class="result-figure"><img class="img-responsive" v-bind:src="`${publicPath}static/img/pages/result/type/${typeId}/figure_02.png`"></div>
                        </div>
                        <div class="medium-col-6of12">
                           <div class="result-header">
                              <span class="result-header__shoulder result-header__shoulder--background-color-fed330">みらいは</span>
                              <h1 class="result-header__heading" style="position: relative; z-index: 1;" v-html="typeSet.workStyleType"></h1>
                           </div>
                           <p class="result-body-text" v-html="typeSet.workStyleTypeBodyText"></p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         
         <div class="certification">
            <div class="component-header-B01">
               <h2 class="component-header-B01__heading">あなたの魅力を活かす資格・講座</h2>
            </div>
            <div class="result-third-section">
               <div class="margin-vert-20px large-margin-vert-100px">
                  <div class="container">
                     <div class="medium-row-gutter-60px large-row-gutter-100px">

                        <div class="medium-col-6of12 large-col-6of12" v-for="(course, i) in courses" :key="i">

                           <div class="course">
                              <div class="course__inner">
                                 <div class="course__content">
                                    <div class="course__thumb">
                                       <img class="img-responsive" v-bind:src="`${publicPath}static/img/pages/result/course/${course.src}`">
                                    </div>
                                    <div class="course__header">
                                       <h3 class="course__heading" v-html="course.name"></h3>
                                    </div>
                                    <div class="course__body" data-mh>
                                       <p class="course__body-text" v-html="course.text"></p>
                                    </div>
                                 </div>
                                 <a class="course-detail-button expanded" v-bind:href="course.alink">
                                    もっと知りたい！
                                    <span class="course-detail-button-icon">
                                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                          <title>arrow right</title>
                                          <polyline points="78.75 29.5 177.25 128 78.75 226.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                                       </svg>
                                    </span>
                                 </a>
                              </div>
                           </div>

                        </div>

                     </div>
                  </div>
                  <div class="margin-vert-30px large-margin-vert-60px" style="position: relative; z-index: 1;">
                     <div class="container-collapse medium-container-narrow">
                        <div class="component-header-C01">
                           <h2 class="component-header-C01__heading">こんな資格・講座もあなたにオススメ</h2>
                        </div>
                     </div>
                     <div class="container medium-container-narrow">

                        <div class="row-gutter-10px medium-row-gutter-40px">

                           <div class="col-6of12 medium-col-4of12" v-for="(rec, i) in recommend" :key="i">
                              <div class="margin-vert-5px medium-margin-vert-15px">
                                 <a class="recommended-course-button expanded" v-bind:href="rec.alink">
                                    <span v-html="rec.name"></span>
                                    <span class="recommended-course-button-icon">
                                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                          <title>arrow right</title>
                                          <polyline points="78.75 29.5 177.25 128 78.75 226.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                                       </svg>
                                    </span>
                                 </a>
                              </div>
                           </div>

                        </div>

                     </div>
                  </div>
                  <div class="margin-vert-30px large-margin-vert-60px">
                     <div class="container">
                        <div class="row-gutter-0px medium-row-gutter-0px justify-content-center">
                           <div class="col-7of12 medium-col-5of12">
                              <div class="margin-vert-10px medium-margin-vert-15px">
                                 <router-link to="/" class="back-shindan-top-button expanded">
                                    診断TOPに戻る
                                    <span class="back-shindan-top-button-icon">
                                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                          <title>arrow left</title>
                                          <polyline points="177.25 226.5 78.75 128 177.25 29.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                                       </svg>
                                    </span>
                                 </router-link>
                              </div>
                           </div>
                        </div>
                        <div class="row-gutter-0px medium-row-gutter-0px justify-content-center">
                           <div class="col-7of12 medium-col-5of12">
                              <div class="margin-vert-10px medium-margin-vert-15px">
                                 <a class="back-ohara-top-button expanded" href="/">
                                    資格の大原TOPに戻る
                                    <span class="back-ohara-top-button-icon">
                                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                          <title>arrow left</title>
                                          <polyline points="177.25 226.5 78.75 128 177.25 29.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                                       </svg>
                                    </span>
                                 </a>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="share-result">
            <div class="share-result-headline">
               <p class="share-result-headline-text">診断結果をSNSでシェアしよう</p>
            </div>

            <div class="row-gutter-0px">
               <div class="col-6of12">
                  <button class="twitter-button" v-on:click="openWindow">
                     <div class="twitter-button-brand-icon-wrapper"><img class="img-responsive" src="../assets/images/pages/result/icon_twitter.png"></div>
                     <div>Twitter</div>
                     <span class="twitter-button-arrow-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                           <title>arrow left</title>
                           <polyline points="177.25 226.5 78.75 128 177.25 29.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                        </svg>
                     </span>
                  </button>
               </div>
               <div class="col-6of12">
                  <button class="facebook-button" v-on:click="shereDialog">
                     <div class="facebook-button-brand-icon-wrapper"><img class="img-responsive" src="../assets/images/pages/result/icon_facebook.png"></div>
                     <div>Facebook</div>
                     <span class="facebook-button-arrow-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                           <title>arrow right</title>
                           <polyline points="78.75 29.5 177.25 128 78.75 226.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                        </svg>
                     </span>
                  </button>
               </div>
               
            </div>
         </div>
      </main>
   </div>
</template>


<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import typeset from "@/assets/data/typeset.json";
import courseService from '@/service/course';
import recommendService from '@/service/recommend';
import 'jquery';
import "jquery-match-height";

export default {
  name: "result",
  data() {
    return {
      typeId: null,
      typeSet: null,
      courses: [],
      recommend: [],
      publicPath: process.env.BASE_URL,
      domain: process.env.VUE_APP_DOMAIN,
      appId: process.env.VUE_APP_FB_APP_ID
    }
  },
  components: {
    Header
  },
  mounted() {
   var self = this;
   window.fbAsyncInit = function() {
      // eslint-disable-next-line
      FB.init({
      appId            : self.$data.appId,
      autoLogAppEvents : true,
      xfbml            : true,
      version          : 'v4.0'
      });
   };
   (function(d){
      var js, id = 'facebook-jssdk'; if (d.getElementById(id)) {return;}
      js = d.createElement('script'); js.id = id; js.async = true;
      js.src = "//connect.facebook.net/ja_JP/all.js";
      d.getElementsByTagName('head')[0].appendChild(js);
   }(document));
  },
  methods: {
     openWindow(){
        const self = this;
        const url = buildURL();
        const popupwindow = (url, title, w, h) => {
         var left = (screen.width/2)-(w/2);
         var top = (screen.height/2)-(h/2);
         return window.open(url, title, 'toolbar=no, location=no, directories=yes, status=yes, menubar=yes, scrollbars=yes, resizable=yes, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
        }
        function buildURL(){
         const text = encodeURIComponent('あなたは' + self.$data.typeSet.personalityType.replace(/<\/?[^>]*>/g,''));
         const url = self.$data.domain + self.$data.publicPath + "result/" + self.$data.typeId + "/";
         const ret = "https://twitter.com/share?url=" + url + "&text=" + text;
         return ret;
        }
        popupwindow(url, "", 660, 300);
     },
     shereDialog(){
      // eslint-disable-next-line
      FB.ui({
         method: 'share',
         href: `${this.$data.domain}${this.$data.publicPath}result/${this.$data.typeId}`,
         }, function(response){
            console.log(response);
         });
     }
  },
  beforeMount() {
   this.typeId = this.$route.params.type;
   this.typeSet = typeset[this.$route.params.type];
   for(let i = 0; i< this.typeSet.course.length; i++ ){
      let id = this.typeSet.course[i];
      this.courses.push( courseService.getCourse(id) );
   }
   for(let i = 0; i< this.typeSet.recommend.length; i++ ){
      let id = this.typeSet.recommend[i];
      this.recommend.push( recommendService.getCourse(id) );
   }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_var/_variables.scss";
@import "@/assets/css/_mixin/_breakpoints.scss";
@import "@/assets/css/pages/result.scss";
</style>